<p-toast />

<p-dialog
    [header]="
        gameSignal()
            ? 'Reviews — ' + effectiveTitle(gameSignal()!)
            : 'Reviews'
    "
    [visible]="visibleSignal()"
    (visibleChange)="onVisibleChange($event)"
    [style]="{ width: '64rem' }"
    [breakpoints]="{ '1200px': '95vw' }"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
>
    @if (gameSignal()) {
    <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)">
        <p-tablist>
            <p-tab value="moderate">
                <span class="flex items-center gap-2">
                    <i class="pi pi-list-check"></i> Moderate
                </span>
            </p-tab>
            <p-tab value="generate">
                <span class="flex items-center gap-2">
                    <i class="pi pi-star"></i> Generate
                </span>
            </p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel value="moderate">
                <div class="flex flex-col gap-4">
                    <!-- Toolbar -->
                    <div
                        class="flex items-center justify-between gap-3 flex-wrap"
                    >
                        <div class="flex items-center gap-3 flex-wrap">
                            <p-selectbutton
                                [options]="kindOptions"
                                optionLabel="label"
                                optionValue="value"
                                [allowEmpty]="false"
                                [ngModel]="kindFilter()"
                                (ngModelChange)="onKindFilterChange($event)"
                            />
                            <p-select
                                [options]="ratingOptions"
                                optionLabel="label"
                                optionValue="value"
                                placeholder="All ratings"
                                [ngModel]="ratingFilter()"
                                (ngModelChange)="ratingFilter.set($event ?? null)"
                                appendTo="body"
                                styleClass="w-40"
                            />
                        </div>
                        <div class="flex items-center gap-2 flex-wrap">
                            <p-button
                                label="Refresh"
                                icon="pi pi-refresh"
                                severity="secondary"
                                outlined
                                size="small"
                                [loading]="loading()"
                                (onClick)="reload()"
                            />
                            <p-button
                                label="Add fake review"
                                icon="pi pi-plus"
                                size="small"
                                (onClick)="openAdd()"
                            />
                            <p-button
                                label="Delete all fakes"
                                icon="pi pi-trash"
                                severity="danger"
                                outlined
                                size="small"
                                [disabled]="fakeCount() === 0 || removeAllBusy()"
                                [loading]="removeAllBusy()"
                                (onClick)="requestRemoveAll()"
                            />
                        </div>
                    </div>

                    <div class="text-sm text-muted-color">
                        Loaded:
                        <strong class="text-color">{{ fakeCount() }}</strong>
                        fake ·
                        <strong class="text-color">{{ realCount() }}</strong>
                        real · showing {{ filteredReviews().length }}
                    </div>

                    @if (listError()) {
                    <p-message
                        severity="error"
                        [text]="listError()!"
                        styleClass="m-0"
                    />
                    }

                    <!-- Reviews table -->
                    <p-table
                        [value]="filteredReviews()"
                        [loading]="loading()"
                        dataKey="Id"
                        [rowTrackBy]="trackById"
                        [rows]="10"
                        [paginator]="filteredReviews().length > 10"
                        [showGridlines]="true"
                        responsiveLayout="scroll"
                    >
                        <ng-template #header>
                            <tr>
                                <th style="width: 6rem">Kind</th>
                                <th style="width: 12rem">Author</th>
                                <th style="width: 5rem">Rating</th>
                                <th>Comment</th>
                                <th style="width: 11rem">Created</th>
                                <th style="width: 7rem">Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-review>
                            <tr>
                                <td>
                                    @if (review.IsFake) {
                                    <p-tag value="FAKE" severity="warn" />
                                    } @else {
                                    <p-tag value="Real" severity="success" />
                                    }
                                </td>
                                <td class="break-words">
                                    {{ authorLabel(review) }}
                                </td>
                                <td>{{ review.Rating }}★</td>
                                <td>
                                    <span
                                        class="whitespace-pre-line break-words"
                                        >{{ review.Comment }}</span
                                    >
                                </td>
                                <td>
                                    {{ review.CreatedAt | date: 'yyyy-MM-dd
                                    HH:mm' }}
                                </td>
                                <td>
                                    <div class="flex items-center gap-2">
                                        <p-button
                                            icon="pi pi-pencil"
                                            severity="warn"
                                            [rounded]="true"
                                            [outlined]="true"
                                            size="small"
                                            [disabled]="!review.IsFake"
                                            [pTooltip]="
                                    review.IsFake
                                        ? 'Edit'
                                        : 'Real reviews cannot be edited'
                                "
                                            (onClick)="openEdit(review)"
                                        />
                                        <p-button
                                            icon="pi pi-trash"
                                            severity="danger"
                                            [rounded]="true"
                                            [outlined]="true"
                                            size="small"
                                            pTooltip="Delete"
                                            (onClick)="requestDelete(review)"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template #emptymessage>
                            <tr>
                                <td
                                    colspan="6"
                                    class="text-center py-8 text-muted-color"
                                >
                                    No reviews match the current filters.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-tabpanel>
            <p-tabpanel value="generate">
                <app-generate-reviews-panel
                    [adminGame]="gameSignal()"
                    [active]="activeTab() === 'generate'"
                    (changed)="reload()"
                />
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
    }

    <ng-template #footer>
        <p-button
            label="Close"
            severity="secondary"
            [text]="true"
            (onClick)="close()"
        />
    </ng-template>
</p-dialog>

<!-- Edit fake review -->
<p-dialog
    [visible]="editReview() !== null"
    (visibleChange)="$event ? null : closeEdit()"
    header="Edit fake review"
    [modal]="true"
    [style]="{ width: '34rem' }"
    [draggable]="false"
    [resizable]="false"
>
    @if (editForm(); as f) {
    <div class="flex flex-col gap-4">
        <div class="grid grid-cols-2 gap-3">
            <div class="flex flex-col gap-1 min-w-0">
                <label class="text-sm font-medium" for="rmd-edit-rating">
                    Rating
                </label>
                <p-select
                    inputId="rmd-edit-rating"
                    [options]="ratingPickOptions"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="f.Rating"
                    (ngModelChange)="updateEditRating($event)"
                    appendTo="body"
                    styleClass="w-full"
                />
            </div>
            <div class="flex flex-col gap-1 min-w-0">
                <label class="text-sm font-medium" for="rmd-edit-created">
                    Created at
                </label>
                <p-datepicker
                    inputId="rmd-edit-created"
                    [ngModel]="f.CreatedAt"
                    (ngModelChange)="updateEditCreatedAt($event)"
                    dateFormat="yy-mm-dd"
                    [showTime]="true"
                    [showIcon]="true"
                    appendTo="body"
                    styleClass="w-full"
                />
            </div>
        </div>
        <div class="flex flex-col gap-1">
            <label class="text-sm font-medium" for="rmd-edit-comment">
                Comment
            </label>
            <textarea
                pTextarea
                id="rmd-edit-comment"
                rows="4"
                class="w-full"
                [ngModel]="f.Comment"
                (ngModelChange)="updateEditComment($event)"
            ></textarea>
        </div>
        @if (editError()) {
        <p-message severity="error" [text]="editError()!" styleClass="m-0" />
        }
    </div>
    }

    <ng-template #footer>
        <p-button
            label="Cancel"
            severity="secondary"
            [text]="true"
            [disabled]="editSaving()"
            (onClick)="closeEdit()"
        />
        <p-button
            label="Save"
            icon="pi pi-check"
            [loading]="editSaving()"
            (onClick)="saveEdit()"
        />
    </ng-template>
</p-dialog>

<!-- Add fake review -->
<p-dialog
    [visible]="addVisible()"
    (visibleChange)="$event ? null : closeAdd()"
    header="Add fake review"
    [modal]="true"
    [style]="{ width: '34rem' }"
    [draggable]="false"
    [resizable]="false"
>
    @if (addForm(); as f) {
    <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-1">
            <label class="text-sm font-medium" for="rmd-add-author">
                Fake author
            </label>
            <p-select
                inputId="rmd-add-author"
                [options]="availableAuthors()"
                optionLabel="Username"
                optionValue="Id"
                [filter]="true"
                filterBy="Username"
                placeholder="Select an author…"
                [ngModel]="f.AuthorId"
                (ngModelChange)="updateAddAuthor($event)"
                [disabled]="availableAuthors().length === 0"
                appendTo="body"
                styleClass="w-full"
            />
            @if (authors().length === 0) {
            <span class="text-xs text-muted-color">
                No active fake authors — add some in the review content bank
                first.
            </span>
            } @else if (availableAuthors().length === 0) {
            <span class="text-xs text-muted-color">
                All active fake authors already have a review for this game.
            </span>
            }
        </div>
        <div class="grid grid-cols-2 gap-3">
            <div class="flex flex-col gap-1 min-w-0">
                <label class="text-sm font-medium" for="rmd-add-rating">
                    Rating
                </label>
                <p-select
                    inputId="rmd-add-rating"
                    [options]="ratingPickOptions"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="f.Rating"
                    (ngModelChange)="updateAddRating($event)"
                    appendTo="body"
                    styleClass="w-full"
                />
            </div>
            <div class="flex flex-col gap-1 min-w-0">
                <label class="text-sm font-medium" for="rmd-add-created">
                    Created at
                </label>
                <p-datepicker
                    inputId="rmd-add-created"
                    [ngModel]="f.CreatedAt"
                    (ngModelChange)="updateAddCreatedAt($event)"
                    dateFormat="yy-mm-dd"
                    [showTime]="true"
                    [showIcon]="true"
                    appendTo="body"
                    styleClass="w-full"
                />
            </div>
        </div>
        <div class="flex flex-col gap-1">
            <label class="text-sm font-medium" for="rmd-add-comment">
                Comment
            </label>
            <textarea
                pTextarea
                id="rmd-add-comment"
                rows="4"
                class="w-full"
                [ngModel]="f.Comment"
                (ngModelChange)="updateAddComment($event)"
            ></textarea>
        </div>
        @if (addError()) {
        <p-message severity="error" [text]="addError()!" styleClass="m-0" />
        }
    </div>
    }

    <ng-template #footer>
        <p-button
            label="Cancel"
            severity="secondary"
            [text]="true"
            [disabled]="addSaving()"
            (onClick)="closeAdd()"
        />
        <p-button
            label="Add"
            icon="pi pi-plus"
            [loading]="addSaving()"
            (onClick)="saveAdd()"
        />
    </ng-template>
</p-dialog>

<!-- Delete confirm -->
<p-dialog
    [visible]="deleteReview() !== null"
    (visibleChange)="$event ? null : cancelDelete()"
    header="Delete review?"
    [modal]="true"
    [style]="{ width: '30rem' }"
    [draggable]="false"
    [resizable]="false"
>
    @if (deleteReview(); as r) {
    <p class="m-0 text-sm">
        This will permanently delete this
        <strong>{{ r.IsFake ? 'fake' : 'real' }}</strong>
        {{ r.Rating }}★ review. This action cannot be undone.
    </p>
    }

    <ng-template #footer>
        <p-button
            label="Cancel"
            severity="secondary"
            [text]="true"
            [disabled]="deleting()"
            (onClick)="cancelDelete()"
        />
        <p-button
            label="Delete"
            icon="pi pi-trash"
            severity="danger"
            [loading]="deleting()"
            (onClick)="confirmDelete()"
        />
    </ng-template>
</p-dialog>

<!-- Delete all fakes confirm -->
<p-dialog
    [visible]="removeAllConfirmVisible()"
    (visibleChange)="removeAllConfirmVisible.set($event)"
    header="Delete all fake reviews?"
    [modal]="true"
    [style]="{ width: '30rem' }"
    [draggable]="false"
    [resizable]="false"
>
    <p class="m-0 text-sm">
        This will permanently remove all
        <strong>{{ fakeCount() }}</strong>
        fake review(s) for this game. Real reviews are not affected.
    </p>

    <ng-template #footer>
        <p-button
            label="Cancel"
            severity="secondary"
            [text]="true"
            (onClick)="cancelRemoveAll()"
        />
        <p-button
            label="Delete all"
            icon="pi pi-trash"
            severity="danger"
            (onClick)="confirmRemoveAll()"
        />
    </ng-template>
</p-dialog>
